import React from 'react';
import { IndicatorProps, components } from 'react-select';
import { OptionTypeBase } from 'react-select/src/types';

export const ClearIndicator = (props: IndicatorProps<OptionTypeBase, boolean>) => {
  return (
    <div className={props.selectProps.classes.clearIndicatorWrapper}>
      <components.ClearIndicator {...props}>{props.children}</components.ClearIndicator>
    </div>
  );
};
